// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CSVImporter_TextButton {
  display: block;
  margin: 0;
  border: 1px solid #808080;
  padding: 0.4em 1em 0.5em;
  border-radius: 0.4em;
  background: #f0f0f0;
  font-size: inherit;
  color: #000;
  cursor: pointer;
}
.CSVImporter_TextButton:hover:not(:disabled) {
  background: rgb(84.1176470588%, 84.1176470588%, 84.1176470588%);
}
.CSVImporter_TextButton:disabled {
  opacity: 0.25;
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./components/csv_import/TextButton.scss","webpack://./theme.scss"],"names":[],"mappings":"AAEA;EACE,cAAA;EACA,SAAA;EACA,yBAAA;EACA,wBAAA;EACA,oBCOa;EDNb,mBCPU;EDQV,kBAAA;EACA,WCVQ;EDWR,eAAA;AADF;AAGE;EACE,+DAAA;AADJ;AAIE;EACE,aAAA;EACA,eAAA;AAFJ","sourcesContent":["@import '../../theme.scss';\n\n.CSVImporter_TextButton {\n  display: block;\n  margin: 0; // override default\n  border: 1px solid $controlBorderColor;\n  padding: 0.4em 1em 0.5em;\n  border-radius: $borderRadius;\n  background: $fillColor;\n  font-size: inherit;\n  color: $fgColor;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    background: darken($fillColor, 10%);\n  }\n\n  &:disabled {\n    opacity: 0.25;\n    cursor: default;\n  }\n}\n","$fgColor: #000;\n$fillColor: #f0f0f0;\n$controlBorderColor: #808080;\n$controlBgColor: #fff;\n\n$invertedTextColor: #f0f0f0;\n$invertedBgColor: #404040;\n\n$textColor: #202020;\n$textSecondaryColor: #808080;\n$textDisabledColor: rgba($textColor, 0.5);\n$errorTextColor: #c00000;\n$titleFontSize: 1.15em; // relative to body font\n\n$borderRadius: 0.4em;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
